export const ExcelDownload = (res: any, range: any) => {
  const url = window.URL.createObjectURL(
    new Blob([res.data], { type: res.headers['content-type'] })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${range.from}_${range.to}.xlsx`);
  document.body.appendChild(link);
  link.click();
};
